import React from 'react';
import { is, isEmpty, isNil } from 'ramda';
import classnames from 'classnames';
import { node, bool, number, oneOf, oneOfType, string, symbol } from 'prop-types';
import { SORT_ASC, SORT_DESC } from 'common/store/collection/reducer';

export {
  SORT_ASC,
  SORT_DESC,
};

export const TD = 'td';
export const TH = 'th';

const Cell = ({
  className,
  children,
  numeric,
  actions,
  sortable,
  sorted,
  tag,
  columnId,
  flex,
  style,
  title,
  alignRight,
  ...props
}) =>
  React.createElement(tag, {
    ...props,
    className: classnames(
      'mdl-data-table__cell',
      className,
      {
        'mdl-data-table__cell--sortable': sortable,
        'mdl-data-table__cell--numeric': numeric,
        'mdl-data-table__cell--actions': actions,
        'mdl-data-table__header--sorted-ascending': sorted === SORT_ASC,
        'mdl-data-table__header--sorted-descending': sorted === SORT_DESC,
        'mdl-data-table__cell--align-right': alignRight,
      },
    ),
    style: { ...style, flex },
    title: title || (is(String, children) ? children : undefined),
  },
  !isEmpty(children) && !isNil(children) ? children : (tag === TD && '-'));

Cell.propTypes = {
  children: node,
  sorted: oneOf([SORT_ASC, SORT_DESC]),
  tag: oneOf([TH, TD]),
  numeric: bool,
  actions: bool,
  sortable: bool,
  columnId: oneOfType([number, string, symbol]),
};

Cell.defaultProps = {
  sorted: null,
  tag: TD,
  numeric: false,
  actions: false,
  sortable: false,
  children: undefined,
  columnId: null,
};

export default Cell;
